export async function getImage(data) {
  try {
    const response = await $nuxt.$axios.$post('/.netlify/functions/map-preview-get', data, {
      headers: { 'Content-Type': 'application/json' },
    })
    return { data: response }
  } catch ({ response }) {
    return response
  }
}

export async function putImage(data) {
  try {
    const response = await $nuxt.$axios.$post('/.netlify/functions/map-preview-put', data, {
      headers: { 'Content-Type': 'application/json' },
    })
    return { data: response }
  } catch ({ response }) {
    return response
  }
}
